import { useEffect } from "react";
import { useNavigate, Outlet } from "react-router-dom";
import { isTokenExist } from "utils/cookies";
import useLoadInits from "hooks/useLoadInits";
import { useHrCompanieSelector } from "hooks/useSelector";
import store from "store";
import PublicContainer from "../Public";

const SelectCompanyLayout = () => {
  const navigate = useNavigate();
  const { companies } = useHrCompanieSelector();
  const skipCheckEndpoint = true;

  useEffect(() => {
    if (isTokenExist()) {
      if (store.get("app.endpoint") && companies.length > 0) {
        navigate(store.get("app.previousPathname") || "/dashboard", {
          replace: true,
        });
      }
    } else {
      navigate("/user/login", { replace: true });
    }
  }, [companies, navigate]);

  useLoadInits(skipCheckEndpoint);

  return (
    <PublicContainer
      className="min-h-screen bg-gradient-to-r from-primary to-pink2"
      inverse
      withFooter={false}
    >
      <Outlet />
    </PublicContainer>
  );
};

export default SelectCompanyLayout;
